import React, { useState, useEffect } from 'react'
import { downloadLink } from "../../helpers/constFIles";
import { InterViewStatus } from './InterViewStatus';
import { IconButton } from '@mui/material';
import { URLS } from '../../helpers/URLS';
import useAxios from "../../helpers/Hooks/useAxios";
import Modal from "react-bootstrap/Modal";
import BadgeOutlinedIcon from "@mui/icons-material/BadgeOutlined";
import AlternateEmailOutlinedIcon from "@mui/icons-material/AlternateEmailOutlined";
import PhoneInTalkOutlinedIcon from "@mui/icons-material/PhoneInTalkOutlined";
import WorkOutlineOutlinedIcon from "@mui/icons-material/WorkOutlineOutlined";
import TimelineOutlinedIcon from "@mui/icons-material/TimelineOutlined";
import PaidOutlinedIcon from "@mui/icons-material/PaidOutlined";
import EventBusyOutlinedIcon from "@mui/icons-material/EventBusyOutlined";
import FlightTakeoffOutlinedIcon from "@mui/icons-material/FlightTakeoffOutlined";
import PsychologyOutlinedIcon from "@mui/icons-material/PsychologyOutlined";
import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined";
import FormatListNumberedOutlinedIcon from "@mui/icons-material/FormatListNumberedOutlined";
import EventAvailableOutlinedIcon from "@mui/icons-material/EventAvailableOutlined";
import AddInterview from './AddInterview';
import moment from 'moment';
import Button from '@mui/material/Button';
import "../../assets/scss/tables.scss";

const initials = (name) => {
  if (!name) return "?";
  const parts = String(name).trim().split(/\s+/);
  return ((parts[0] ? parts[0][0] : "") +
    (parts.length > 1 ? parts[parts.length - 1][0] : "")).toUpperCase();
};

const splitSkills = (value) =>
  String(value || "").split(",").map((s) => s.trim()).filter(Boolean);

const Fact = ({ icon, label, value }) => (
  <div className="wh-fact">
    <span className="wh-fact-icon">{icon}</span>
    <div className="wh-fact-text">
      <span className="wh-fact-label">{label}</span>
      <span className="wh-fact-value">{value || "--"}</span>
    </div>
  </div>
);

const ViewCandidateDetailsModal = ({ candidateID, show, onHide }) => {

  const [candidate, setCandidate] = useState({})

  const [statusList, setStatusList] = useState([]);

  const [selectedRound, setSelectedRound] = useState(0);

  const [currentRound, setCurrentRound] = useState(0);

  const [selectedRoundData, setSelectedRoundData] = useState({});

  const [editInterview, setEditInterview] = useState(false);

  const { fetchData } = useAxios();

  useEffect(() => {
    if (candidateID) {
      getParticularCandidate(candidateID);
    }
  }, [candidateID])

  useEffect(() => {
    let numberOfRounds = [];
    for (let i = 0; i < candidate?.job?.numberOfRounds; i++) {
      numberOfRounds.push(i);
    }
    setStatusList([...numberOfRounds]);
    if (candidate && candidate.interviews && candidate.interviews.length > 0) {
      if (candidate.job.numberOfRounds === candidate.interviews.length) {
        if (candidate.interviews.at(-1).status === 'Selected' || candidate.interviews.at(-1).status === 'Rejected') {
          setSelectedRound(0);
          setCurrentRound(0);
        } else {
          setSelectedRound(candidate.interviews.length - 1);
          setCurrentRound(candidate.interviews.length - 1);
        }
      } else {
        candidate.interviews.forEach((interview, i) => {
          if (interview.status === 'Selected') {
            setSelectedRound(i + 1);
            setCurrentRound(i + 1)
          } else if (interview.status === 'Rejected') {
            setSelectedRound(i);
            setCurrentRound(i)
          } else {
            setSelectedRound(i);
            setCurrentRound(i)
          }
        })
      }
    }
  }, [candidate])

  useEffect(() => {
    if (candidate && candidate.interviews && candidate.interviews.length > 0 && candidate.interviews[selectedRound]) {
      setSelectedRoundData({ ...candidate.interviews[selectedRound], round: +candidate.interviews[selectedRound].round })
    } else {
      setSelectedRoundData({
        round: selectedRound ? selectedRound + 1 : 1
      })
    }
  }, [selectedRound, candidate])

  const getParticularCandidate = async (candidateID) => {
    const { status, data } = await fetchData({ url: URLS.getParticularCandidate(candidateID), method: 'get' });
    if (status === 200) {
      setCandidate(data);
    } else {
      setCandidate({})
    }
  }

  return (
    <div>
      <Modal show={show} onHide={() => { setEditInterview(false); onHide(); }} size="lg" className="wh-modal">
        <Modal.Header closeButton>
          <Modal.Title>Candidate Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>

          <div className="wh-profile-hero">
            <div className="wh-avatar">{initials(candidate.name)}</div>
            <div className="wh-profile-id">
              <h5>{candidate.name || "--"}</h5>
              <p>{candidate?.job?.jobTitle || "No job linked"}</p>
            </div>
            <span className="wh-pill wh-profile-code">{candidate.candidateID}</span>
          </div>

          <div className="wh-facts-grid">
            <Fact icon={<AlternateEmailOutlinedIcon />} label="Email" value={candidate.email} />
            <Fact icon={<PhoneInTalkOutlinedIcon />} label="Phone" value={candidate.phone} />
            <Fact icon={<BadgeOutlinedIcon />} label="PAN / Aadhar" value={candidate.AADHAR || candidate.PAN} />
            <Fact icon={<TimelineOutlinedIcon />} label="Experience"
              value={candidate.experience ? `${candidate.experience} Years` : ""} />
            <Fact icon={<PaidOutlinedIcon />} label="Current CTC"
              value={candidate.currentCTC ? `${candidate.currentCTC} LPA` : ""} />
            <Fact icon={<PaidOutlinedIcon />} label="Expected CTC"
              value={candidate.expectedCTC ? `${candidate.expectedCTC} LPA` : ""} />
            <Fact icon={<EventBusyOutlinedIcon />} label="Notice Period"
              value={candidate.noticePeroid ? `${candidate.noticePeroid} Days` : ""} />
            <Fact icon={<FlightTakeoffOutlinedIcon />} label="Will Join Early"
              value={candidate.willJoinEarly ? `${candidate.willJoinEarly} Days` : ""} />
            <Fact icon={<WorkOutlineOutlinedIcon />} label="Position" value={candidate?.job?.jobTitle} />
          </div>

          <h6 className="wh-section-title"><PsychologyOutlinedIcon />Skills</h6>
          {splitSkills(candidate.skills).length > 0
            ? <div className="wh-pills">
              {splitSkills(candidate.skills).map((skill, i) =>
                <span className="wh-pill" key={i}>{skill}</span>)}
            </div>
            : <p className="wh-section-empty">No skills recorded for this candidate.</p>}

          <h6 className="wh-section-title"><FormatListNumberedOutlinedIcon />Interview Rounds</h6>
          {statusList.length > 0
            ? <div className="wh-rounds">
              {statusList.map(i => {
                const round = candidate?.interviews?.[i];
                const status = round?.status;
                const tone =
                  status === 'Selected' ? 'is-selected' :
                    status === 'Rejected' ? 'is-rejected' :
                      status === 'Hold' ? 'is-hold' :
                        round ? 'is-scheduled' : '';
                return (
                  <button key={i} type="button"
                    className={`wh-round ${tone}${selectedRound === i ? ' is-current' : ''}`}
                    onClick={() => setSelectedRound(i)}
                    disabled={
                      (round && status === '') ? false :
                        (round && status === 'Selected') ? false :
                          (round && status === 'Rejected') ? false :
                            (currentRound >= i) ? false : true
                    }>
                    <em>{i + 1}</em>
                    <span>{status || (round ? 'Scheduled' : 'Not scheduled')}</span>
                  </button>
                );
              })}
            </div>
            : <p className="wh-section-empty">This job has no interview rounds configured.</p>}

          <div className="wh-round-panel">
            {editInterview ?
              <AddInterview setEditInterview={setEditInterview}
                selectedRoundData={{ ...selectedRoundData, candidateID: candidate.candidateID }}
                reloadCandidate={() => { getParticularCandidate(candidate.candidateID) }}
              /> :
              <>
                <div className="wh-round-head">
                  <h6>Round {selectedRoundData?.round || selectedRound + 1}</h6>
                  {(!selectedRoundData?.status || selectedRoundData?.status === '') && (
                    <Button variant="contained" startIcon={<EventAvailableOutlinedIcon />}
                      onClick={() => { setEditInterview(true) }}>
                      Schedule Round {selectedRoundData?.round || selectedRound + 1}
                    </Button>
                  )}
                </div>

                <div className="wh-facts-grid">
                  <Fact icon={<FactCheckOutlinedIcon />} label="Round Type" value={selectedRoundData?.roundType} />
                  <Fact icon={<BadgeOutlinedIcon />} label="Scheduled By"
                    value={selectedRoundData?.scheduledBy?.employeeName
                      ? `${selectedRoundData.scheduledBy.employeeName} (${selectedRoundData.scheduledBy.employeeCode})` : ""} />
                  <Fact icon={<BadgeOutlinedIcon />} label="Interviewer"
                    value={selectedRoundData?.scheduledTo?.employeeName
                      ? `${selectedRoundData.scheduledTo.employeeName} (${selectedRoundData.scheduledTo.employeeCode})` : ""} />
                  <Fact icon={<EventAvailableOutlinedIcon />} label="Start Time"
                    value={selectedRoundData?.startTime ? moment(selectedRoundData.startTime).format('lll') : ""} />
                  <Fact icon={<EventBusyOutlinedIcon />} label="End Time"
                    value={selectedRoundData?.endTime ? moment(selectedRoundData.endTime).format('lll') : ""} />
                  <Fact icon={<FactCheckOutlinedIcon />} label="Status"
                    value={selectedRoundData?.roundType
                      ? <InterViewStatus status={selectedRoundData?.status} /> : ""} />
                </div>

                {selectedRoundData?.review?.length > 0 && (
                  <>
                    <h6 className="wh-section-title">Performance Score</h6>
                    <ul className="wh-scores">
                      {selectedRoundData.review.map((item, i) => (
                        <li key={i}>
                          <span className="wh-score-label">{item?.label}</span>
                          <span className="wh-pill wh-pill-good">Rating {item?.rating}</span>
                          <span className="wh-score-note">{item?.value}</span>
                        </li>
                      ))}
                    </ul>
                  </>
                )}

                {selectedRoundData?.comments && (
                  <>
                    <h6 className="wh-section-title">Comments</h6>
                    <p className="wh-rich-text">{selectedRoundData.comments}</p>
                  </>
                )}
              </>
            }
          </div>

        </Modal.Body>
      </Modal>
    </div>
  )
}

export default ViewCandidateDetailsModal;
